import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme, Checkbox } from '@mui/material'
import { FilterInput } from '../../common/filterInput'
import DropDownOA from '../../common/dropDownOA'
import LineInputV3 from '../../common/lineInputV3'
import { ValidateAadhaar, calculateFinalAmounts, cellStyles, excelCellStyles, headCellStyles, pancardValidation, paymentTypeStyles, tablefilterLabel1, tablefilterLabel2, excelHeadCellStyles } from './const'
import moment from 'moment'
import { focusElemnt, getInt, getPaymentTypeBackground, isValueinObjectArray, updateObjectInArray } from '../../common/helper'
import { useAtom } from 'jotai'
import { destinationCityAtom, sourceCityAtom } from '../../common/jotaiState/deliverymemoStateAtoms'
const DeliveryMemoTable = (props) => {
  const { tableData, selectedTab, data, methods, selectedLRs } = props
  const { selectedLrs, appliedMoreFilter, memoFromDate, memoToDate, loginData, showMore, excelData, setexcelData } = data
  const { setSelectedLrs, setTableData } = methods
  const [sourceCity ] = useAtom(sourceCityAtom)
  const [destinationCity] = useAtom(destinationCityAtom)  
  const theme = useTheme()
  const { palette: cs } = theme

  const [filterValues, setFilterValues] = useState({})
  const [filteredData, setfilteredData] = useState(tableData)
  const headerRef = useRef(null);
  const totalRowRef = useRef(null);
  const [grandTotal, setGrandTotal] = useState([])
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()

      const focusableElements = document.querySelectorAll('input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])')
      const currentIndex = Array.from(focusableElements).indexOf(event.target)
      const nextIndex = (currentIndex + 1) % focusableElements.length
      focusableElements[nextIndex].focus()
    }
  }

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      // Clean up the event listener when the component unmounts
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])
  useEffect(() => {
    const rowKeys = [
      '', '', 'TotalDues', '', '', '', '', 'Units',
      'AdditionalDeliveryCartage', 'HomeDeliveryChg', 'ExtraHamli',
      'DemurrageChg', 'Discount', 'DeliveryGST', 'finalAmount'
    ];
    const keysToSum = rowKeys.filter(Boolean);
    const grandTotalRow = keysToSum.reduce((acc, key) => {
      const sum = tableData.reduce((total, row) => {
        const value = row[key];
        return total + (typeof value === 'number' ? value : 0);
      }, 0);
    
      acc[key] = sum;
      return acc;
    }, {});    
    const grandTotalArray = rowKeys.map((key, index) => (index === 1 ? 'Grand Total' : key ? grandTotalRow[key].toFixed(2) ?? 0 : ''))
    setGrandTotal(grandTotalArray);
    setfilteredData(tableData)
    const headerRow = headerRef.current;
    const totalRow = totalRowRef.current;

    if (!headerRow || !totalRow || !tableData.length) return
    const syncWidths = () => {
      const headerCells = headerRow.children;
      const totalCells = totalRow.children;

      for (let i = 0; i < headerCells.length; i++) {
        const width = headerCells[i].getBoundingClientRect().width;
        if(totalCells[i]) totalCells[i].style.width = `${width}px`
        else console.log('totalCells[i] not found')
      }
    };
    setTimeout(() => {
      syncWidths();
    }, 300);
    const observer = new MutationObserver(() => {
      syncWidths();
    });
    observer.observe(headerRow, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [tableData])

  useEffect(() => {
    if (selectedLRs.length > 0) {
      setexcelData(selectedLRs)
    } else {
      setexcelData(filteredData)
    }
  }, [selectedLRs])

  const handleFilterChange = (columnId, value) => {
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [columnId]: value,
    }))
  }
  useEffect(() => {
    const filteredDataTemp = tableData.filter((item) => {
      return tablefilterLabel2.every((column) => {
        const filterValue = filterValues[column.id] || ''
        const value = item[column.id]
        return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
      })
    })
    setfilteredData(filteredDataTemp)
  }, [filterValues])

  const updateLrAndSelectedLr = (e, BookingID, updateKey) => {
    const updatedSelectedLrs = updateObjectInArray(selectedLrs, 'BookingID', BookingID, updateKey, e.target.value)
    setSelectedLrs(calculateFinalAmounts(updatedSelectedLrs))
    const updatedTableData = updateObjectInArray(tableData, 'BookingID', BookingID, updateKey, e.target.value)
    setTableData(calculateFinalAmounts(updatedTableData))
  }
  const chkBoxNavigation = (e, nextId, prevId) => {
    if (e.key === 'ArrowUp') {
      focusElemnt(prevId)
    }
    if (e.key === 'ArrowDown') {
      focusElemnt(nextId)
      e.preventDefault()
    }
    if (e.key === 'Enter') {
      setTimeout(() => {
        focusElemnt('memoDeliveryReceiver')
      }, 0)
    }
  }
  return (
    <Box style={{ marginLeft: '5px' }}>
      <TableContainer
        className="delivery-memo-table scroll"
        component={Paper}
        sx={{ borderRadius: '8px', border: '1px solid #aeaeae', height: showMore ? 'calc( 50vh - 120px)' : 'calc( 70vh - 100px)', overflow: 'auto', margin: '0px 0px' }}
      >
        <Table aria-label="a dense table" id="delivery-memo-excel-tbl" style={{ display: 'none' }}>
          <TableHead style={{ fontWeight: 'bold' }}>
            <TableRow>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontWeight: '600', textAlign: 'left' }}
                colSpan={4}
              >
                <h3 style={{ paddingLeft: '17px', fontSize: '18px', }}>Delivery Memo: Pending Delivery At My Branch</h3>
              </TableCell>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontWeight: '600', textAlign: 'left' }}
                colSpan={9}
              >
                <h3 style={{ paddingLeft: '17px', fontSize: '18px' }}>Company Name : {loginData.strCompanyName}</h3>
              </TableCell>
            </TableRow>
            <TableRow><TableCell colSpan={14}></TableCell></TableRow>
            <TableRow style={{ color: '#444444' }}>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  backgroundColor: '#0086FF',
                  color: '#444444',
                  fontSize: '16px',
                  fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={2}
              >
                From Memo Date
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  backgroundColor: '#0086FF',
                  color: '#444444',
                  fontSize: '16px',
                  fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={2}
              >
                To Memo Date
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  backgroundColor: '#0086FF',
                  color: '#444444',
                  fontSize: '16px',
                  fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={5}
              >
                Source City
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  backgroundColor: '#0086FF',
                  color: '#444444',
                  fontSize: '16px',
                  fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={4}
              >
                Destination City
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={2}
              >
                {moment(memoFromDate).format('DD-MM-YYYY')}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={2}
              >
                {moment(memoToDate).format('DD-MM-YYYY')}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px', fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={5}
              >
                {sourceCity.map((item) => item.sourceCityList).join(', ')}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold',
                  color: 'black',
                  fontSize: '16px',
                  fontFamily: 'Roboto',
                  fontWeight: '600',
                  textAlign: 'left',
                  borderRight: '1px solid #ccc',
                }}
                colSpan={4}
              >
                {destinationCity.destinationCityName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={14}></TableCell>
            </TableRow>
            <TableRow style={{ color: '#444444' }}>
              {appliedMoreFilter?.hasOwnProperty('PaymentType') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Payment Type
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ChallanNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Challan No.
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('LRNO') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  LR No.
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ManualLRNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Offline LR No.
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('Sender') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={3}
                >
                  Sender
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('SenderMobileNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Sender No.
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('SenderGSTN') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Sender GSTIN
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('SenderEmailID') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Sender Email ID
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('RecName') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Receiver
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('RecMobileNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Receiver No.
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ReceiverEmailID') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Receiver Email ID
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ReceiverGSTN') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Receiver GSTIN
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('PinCode') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#0086FF',
                    color: '#444444',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  Pincode
                </TableCell>
              )}
            </TableRow>

            <TableRow style={{ color: '#444444' }}>
              {appliedMoreFilter?.hasOwnProperty('PaymentType') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.PaymentType}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ChallanNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.ChallanNo}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('LRNO') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.LRNO}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ManualLRNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.ManualLRNo}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('Sender') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={3}
                >
                  {appliedMoreFilter?.Sender}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('SenderMobileNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.SenderMobileNo}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('SenderGSTN') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.SenderGSTN}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('SenderEmailID') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.SenderEmailID}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('RecName') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.RecName}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('RecMobileNo') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.RecMobileNo}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ReceiverEmailID') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.ReceiverEmailID}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('ReceiverGSTN') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.ReceiverGSTN}
                </TableCell>
              )}
              {appliedMoreFilter?.hasOwnProperty('PinCode') && (
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: '16px',
                    fontFamily: 'Roboto',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #ccc',
                  }}
                  colSpan={2}
                >
                  {appliedMoreFilter?.PinCode}
                </TableCell>
              )}
            </TableRow>
            <TableRow>
              <TableCell colSpan={14}></TableCell>
            </TableRow>
          </TableHead>
          <TableHead className="table-consignment-head" style={{ background: cs.primary.main, zIndex: 2 }}>
            <TableRow>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '7%', backgroundColor: cs.primary.main, textAlign: 'left' }}>
                LR Number & <br /> Offline LR No.
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '6%', backgroundColor: cs.primary.main, textAlign: 'left' }}>
                Payment Type <br /> & LR Due Amt.
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '7%', backgroundColor: cs.primary.main, textAlign: 'left' }}>
                Source City <br />
                Source Branch
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '7%', backgroundColor: cs.primary.main, textAlign: 'left' }}>
                Dest. City <br /> Dest. Branch
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '7%', backgroundColor:cs.primary.main, textAlign:'left'}}>
                Receiver Name <br /> Receiver No.
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize:'16px', width: '7%', backgroundColor:cs.primary.main, textAlign:'left'}}>
                Receive Date <br /> & Challan No.
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '6%', backgroundColor: cs.primary.main, textAlign: 'right' }}>
                Total No. <br /> of Units
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '5%', backgroundColor: cs.primary.main, textAlign: 'right' }}>
                Delivery <br /> Cartage
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '5%', backgroundColor: cs.primary.main, textAlign: 'right' }}>
                Delivery
                <br /> Hamali
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '5%', backgroundColor: cs.primary.main, textAlign: 'right' }}>
                Del. Op.
                <br />  Hamali
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '7%', backgroundColor: cs.primary.main, textAlign: 'right' }}>
                Demurrage <br /> Charges
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '5%', backgroundColor: cs.primary.main, textAlign: 'right' }}>
                Disc. <br /> on Delivery
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '5%', backgroundColor: cs.primary.main, textAlign: 'right' }}>
                Delivery <br /> GST
              </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', width: '5%', backgroundColor: cs.primary.main, textAlign: 'right', borderTopRightRadius: '8px' }}>
                Total <br /> Net Amt.
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {excelData.map((el, index) => (
              <DeliveryMemoExcelRow
                key={'table-memosdsds' + index}
                index={index}
                data={el}
                cs={cs}
                selectedTab={selectedTab}
                methods={methods}
                updateLrAndSelectedLr={updateLrAndSelectedLr}
              />
            ))}
          </TableBody>

        </Table>
        <Table aria-label="a dense table" id='del-memo-normal-table'>
          <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', background: cs.primary.main, zIndex: 2 }}>
            <TableRow ref={headerRef}>
              <TableCell style={{ ...headCellStyles, width: '2%', textAlign: 'center', borderTopLeftRadius: '8px' }}>
                {/* <Checkbox tabIndex={0} id="memoTableHeadCheck" style={{ color: 'white' }}/> */}
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%' }}>
                LR Number & <br /> Offline LR No.
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '6%' }}>
                Payment Type <br /> & LR Due Amt.
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%' }}>
                Source City <br />
                Source Branch
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%' }}>
                Dest. City <br /> Dest. Branch
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%' }}>
                Receiver Name <br /> Receiver No.
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%' }}>
                Receive Date <br /> & Challan No.
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '6%', textAlign: 'right' }}>
                Total No. <br /> of Units
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', textAlign: 'right' }}>
                Delivery <br /> Cartage
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', textAlign: 'right' }}>
                Delivery
                <br /> Hamali
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', textAlign: 'right' }}>
                Del. Op.
                <br />  Hamali
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%', textAlign: 'right' }}>
                Demurrage <br /> Charges
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', textAlign: 'right' }}>
                Disc. on <br />  Delivery
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', textAlign: 'right' }}>
                Delivery <br /> GST
              </TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', textAlign: 'right', borderTopRightRadius: '8px' }}>
                Total <br /> Net Amt.
              </TableCell>
            </TableRow>
            <TableRow style={{ position: 'sticky', top: '0', zIndex: 3, background: '#fff' }}>
              <TableCell style={{ ...cellStyles, textAlign: 'center' }}> </TableCell>
              {tablefilterLabel1.map((filterGroup, index) => (
                <TableCell key={index} style={cellStyles}>
                  <Box>
                    {Array.isArray(filterGroup) ? (
                      filterGroup.map((filter, subIndex) => (
                        <FilterInput
                          tabIndex={3}
                          key={subIndex}
                          label={filter.name}
                          marginB={filter.marginB || false}
                          disabled={filter.disabled}
                          value={filterValues[filter.id] || ''}
                          onChange={(e) => handleFilterChange(filter.id, e.target.value)}
                        />
                      ))
                    ) : (
                      <FilterInput
                        tabIndex={3}
                        label={filterGroup.name}
                        marginB={filterGroup.marginB || false}
                        disabled={filterGroup.disabled}
                        value={filterValues[filterGroup.id] || ''}
                        onChange={(e) => handleFilterChange(filterGroup.id, e.target.value)}
                      />
                    )}
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((el, index) => (
              <DeliveryMemoRow
                key={'table-memo' + index}
                index={index}
                data={el}
                cs={cs}
                selectedTab={selectedTab}
                propData={data}
                methods={methods}
                updateLrAndSelectedLr={updateLrAndSelectedLr}
                chkBoxNavigation={chkBoxNavigation}
                filteredData={filteredData}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer className="delivery-memo-table scroll" component={Paper} sx={{  height: '40px', overflow: 'auto', margin: '0px 0px' }}>
        <Table aria-label="a dense table">
          <TableBody>
            <TableRow ref={totalRowRef}>
              {grandTotal.map((el, index) => (
                <TableCell key={'total-rs3w' + index} style={{...cellStyles, textAlign: 'right',fontWeight: 'bold',height: '42px'}}>
                  {el}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
const DeliveryMemoRow = (props) => {
  const { index, data, cs, selectedTab, propData, methods, updateLrAndSelectedLr, chkBoxNavigation, filteredData } = props
  const { selectedLrs, vehicleList, loginData, checkboxStates } = propData
  const { updateSelectedList, updateAlertError } = methods
  const isChecked = isValueinObjectArray(selectedLrs, data?.BookingID, 'BookingID')
  const {
    bulkDeliveryCheck = false,
    reciverName = '',
    reciverPhone = '',
    getIdProof: receiverIdList = '',
    selectedRecIdType = '',
    ReIdNumber = '',
  } = isChecked ? propData : {}
  const {
    methodOfPayment: MOPList,
    selectedMOP = '',
    partyList,
    selectedParty = '',
    selectedVehicle = '',
    remarks = '',
  } = isChecked ? propData : {}
  const { setRecieverName, setReceiverPhone, setselectedRecIdType, setReIdNumber, setSelectedMOP } = methods
  const { setSelectedParty, setSelectedVehicle, setRemarks, bulkDeliver, setSelectedLrs, onLrClick } = methods
  const isDisabled = bulkDeliveryCheck || !isChecked
  const [idProof, setIdProof] = useState('')
  const [mop, setMop] = useState('')
  const [party, setParty] = useState('')
  const [vehicle, setVehicle] = useState('')
  useEffect(() => {
    if (selectedRecIdType !== '') {
      setIdProof(selectedRecIdType)
    } else {
      setIdProof(' ')
    }
  }, [selectedRecIdType])
  useEffect(() => {
    if (selectedMOP !== '') {
      setMop(selectedMOP)
    } else {
      setMop(' ')
    }
  }, [selectedMOP])
  useEffect(() => {
    if (selectedParty !== '') {
      setParty(selectedParty)
    } else {
      setParty(' ')
    }
  }, [selectedParty])
  useEffect(() => {
    if (selectedVehicle !== '') {
      setVehicle(selectedVehicle)
    } else {
      setVehicle(' ')
    }
  }, [selectedVehicle])
  const handleIdProofInput = (e, index) => {
    let idValue = e.target.value;
    if (idValue !== '' && selectedRecIdType.IDProof === 'PAN Card') {
      if (pancardValidation(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: 'Invalid PAN Card Number', close: resetValues(), nextId: `idNo-${index}` })
      }
    } else if (idValue !== '' && selectedRecIdType.IDProof === 'Aadhar Card') {
      if (ValidateAadhaar(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: 'Invalid Aadhaar Number', close: resetValues() })
      }
    } else {
      if (idValue !== '') {
        setReIdNumber(idValue)
      }
    }
  }

  const resetValues = () => {
    setReIdNumber('')
    // updateAlertError({ show: false, msg: '' })
    // focusElemnt(`idNo-${index}`)
  }

  return (
    <TableRow>
      <TableCell tabIndex={0} style={{ ...cellStyles, textAlign: 'center' }}>
        <Checkbox tabIndex={0} id={'memoTablerowCheck' + index}
          checked={checkboxStates[data.BookingID] || false}
          onChange={(e) => updateSelectedList(e, data, selectedLrs, setSelectedLrs)}
          onKeyDown={(e) => chkBoxNavigation(e, index < filteredData?.length ? `memoTablerowCheck${index + 1}` : 'memoTablerowCheck0', index === 0 ? 'memoExportPdfBtn' : `memoTablerowCheck${index - 1}`)}
        />
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <div style={{ padding: 0, color: cs.primary.main, textDecoration: 'underline', cursor: 'pointer', textAlign: 'left' }} onClick={() => onLrClick(data?.BookingID)} >{data?.LRNO}</div>
          <Typography>{data?.ManualLRNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <div style={{ ...paymentTypeStyles }}>
            <span
              style={{
                backgroundColor: getPaymentTypeBackground(data?.PaymentType),
                padding: '4px 9px',
                borderRadius: '30px',
                textDecoration: data?.PaymentType?.length > 7 ? 'underline' : '',
              }}
              title={data?.PaymentType}
            >
              {data?.PaymentType}
            </span>
          </div>
          <Typography sx={{ padding: '4px 9px 4px 18px' }}>{data?.TotalDues}</Typography>
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <Typography>{data?.SourceCity}</Typography>
          {/* <Tooltip title={data?.SourceBranch} arrow enterTouchDelay={0} placement="top" className={{ tooltip: 'custom-tooltip' }}> */}
          <Typography
            style={{
              padding: 0,
              display: 'block',
              textOverflow: 'ellipsis',
              textDecoration: data?.SourceBranch?.length > 15 ? 'underline' : '',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '9vw',
            }}
            title={data?.SourceBranch}
          >
            {data.SourceBranch}
          </Typography>
          {/* </Tooltip> */}
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <Typography>{data?.DestinationCity}</Typography>
          {/* <Tooltip title={data?.DestinationBranch} arrow enterTouchDelay={0} placement="top" className={{ tooltip: 'custom-tooltip' }}> */}
          <Typography
            style={{
              padding: 0,
              display: 'block',
              textOverflow: 'ellipsis',
              textDecoration: data?.DestinationBranch?.length > 15 ? 'underline' : '',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '9vw',
            }}
            title={data?.DestinationBranch}
          >
            {data.DestinationBranch}
          </Typography>
          {/* </Tooltip> */}
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <Typography>{data?.RecName}</Typography>
          <Typography>{data?.RecMobileNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <Typography>{data.ReceiptDate}</Typography>
          <Typography>{data?.ChallanNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <Typography className="input--content disabled">{data.Units}</Typography>
          <LineInputV3
            placeholder="Received By"
            value={reciverName}
            onBlur={(e) => setRecieverName(e.target.value)}
            disabled={isDisabled}
          />
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <LineInputV3
            placeholder="0"
            disabled={!isChecked}
            value={data?.AdditionalDeliveryCartage || 0}
            filter={getInt}
            onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'AdditionalDeliveryCartage')}

          />
          <LineInputV3
            placeholder="Receiver No."
            value={reciverPhone}
            filter={getInt}
            maxLength={loginData?.MobileNoULimit}
            disabled={isDisabled}
            onBlur={(e) => setReceiverPhone(e.target.value)}
          />
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <LineInputV3
            placeholder="0"
            disabled={!isChecked}
            value={data?.HomeDeliveryChg || 0}
            filter={getInt}
            onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'HomeDeliveryChg')}
          />
          <DropDownOA
            label="ID Proof"
            data={receiverIdList}
            value={idProof?.IDProof || idProof}
            defaultvalue={idProof?.IDProof || idProof}
            idKey={'IDProofid'}
            dataKey={'IDProof'}
            resetFlag={!bulkDeliveryCheck}
            onSelect={(val) => setselectedRecIdType(val)}
            disabled={isDisabled}
            noCross={true}
            listWidth={'200px'}
            onSelResetVal={true}
          />
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <LineInputV3
            placeholder="0"
            disabled={!isChecked}
            value={data?.ExtraHamli || 0}
            filter={getInt}
            onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'ExtraHamli')}
          />
          <LineInputV3 id={`idNo-${index}`} placeholder="ID Number" value={ReIdNumber}
            onBlur={(e) => handleIdProofInput(e, index)} disabled={isDisabled} />
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <LineInputV3
            placeholder="0"
            disabled={!isChecked}
            value={data?.DemurrageChg || 0}
            filter={getInt}
            onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'DemurrageChg')}
          />
          <DropDownOA
            label="Pymt. Mode"
            value={mop?.ModeName || mop}
            defaultvalue={mop?.ModeName || mop}
            onSelect={(val) => setSelectedMOP(val)}
            data={MOPList}
            idKey={'ModeID'}
            dataKey={'ModeName'}
            resetFlag={!bulkDeliveryCheck}
            disabled={isDisabled || data?.PaymentTypeID === 5 || data?.PaymentTypeID === 10}
            noCross={true}
            listWidth={'200px'}
            onSelResetVal={true}
          />
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <LineInputV3
            placeholder="0"
            disabled={!isChecked}
            value={data?.Discount || 0}
            filter={getInt}
            onBlur={(e) => updateLrAndSelectedLr(e, data.BookingID, 'Discount')}
          />
          <DropDownOA
            label="Party"
            defaultvalue={party?.Party || party}
            value={party?.Party || party}
            data={partyList}
            dataKey={'Party'}
            idKey={'PartyID'}
            resetFlag={!bulkDeliveryCheck}
            onSelect={(val) => setSelectedParty(val)}
            noCross={true}
            listWidth={'200px'}
            disabled={isDisabled || selectedMOP?.ModeName !== 'Credit'}
            onSelResetVal={true}
          />
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <LineInputV3 value={data?.DeliveryGST || 0} disabled={true} />
          <DropDownOA
            id="memoDeliveryVehicle"
            nextId="memoDeliveryRemarks"
            prevId="memoDeliveryReceiverParty"
            label="Veh. No."
            data={vehicleList}
            defaultvalue={vehicle?.VehicleNo || vehicle}
            value={vehicle?.VehicleNo || vehicle}
            dataKey={`VehicleNo`}
            idKey={`VehicleID`}
            resetFlag={!bulkDeliveryCheck}
            onSelect={(val) => setSelectedVehicle(val)}
            disabled={isDisabled}
            noCross={true}
            listWidth={'200px'}

          />
        </Box>
      </TableCell>
      <TableCell style={cellStyles}>
        <Box>
          <LineInputV3 value={data?.finalAmount || 0} disabled={true} />
          {/* total amount*/}
          <LineInputV3 placeholder="Remark" value={remarks} disabled={isDisabled} onBlur={(e) => setRemarks(e.target.value)} />
        </Box>
      </TableCell>
    </TableRow>
  )
}
const DeliveryMemoExcelRow = (props) => {
  const { data = {} } = props
  return (
    <TableRow>
      <TableCell style={excelCellStyles}>
        {`\u200B${data.LRNO}`}
        <br />
        {data?.ManualLRNo}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.PaymentType}
        <br />
        {data?.TotalDues}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.SourceCity}
        <br />
        {data?.SourceBranch}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.DestinationCity}
        <br />
        {data?.DestinationBranch}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.RecName}
        <br />
        {data?.RecMobileNo}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data.ReceiptDate}
        <br />
        {data?.ChallanNo}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data.Units}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.AdditionalDeliveryCartage || 0}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.HomeDeliveryChg || 0}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.ExtraHamli || 0}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.DemurrageChg || 0}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.Discount || 0}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.DeliveryGST || 0}
      </TableCell>
      <TableCell style={excelCellStyles}>
        {data?.finalAmount || 0}
      </TableCell>
    </TableRow>
  )
}
export default DeliveryMemoTable
